import { render } from "./RouterViewLayout.vue?vue&type=template&id=0e5945dc"
import script from "./RouterViewLayout.vue?vue&type=script&lang=js"
export * from "./RouterViewLayout.vue?vue&type=script&lang=js"

import "./RouterViewLayout.vue?vue&type=style&index=0&id=0e5945dc&lang=scss"
script.render = render

export default script